export const UnsubExperiment = Object.freeze({
  'Unsubscribe': 'unsubscribe',
  'Profile': 'profile',
  'Membership': 'membership',
  'OptOut': 'opt_out',
  'Unregister': 'unregister',
})
